import { apiOfficialClient } from './config.js';
import { apiClientPbx } from '@/api/sipmovil_auth_api.js'
// characters=${query}&username=${username}&
export default {
  getContacts(query, username) {
    return apiOfficialClient.get(
      `search/?username=${username}&characters=${query}` // &page=${page}
    );
  },
  getPbxContacts(query) {
    return apiClientPbx.get(`api/whatsapp/contacts/?characters=${query}`);
  },
  updateCustomName(userName, token, contact) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.put(
      `update-name/?username=${userName}&phone=${contact.number.trim()}&name=${contact.name}`
    );
  },
};
